var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "modal" } }, [
    _c(
      "div",
      {
        staticClass: "modal common",
        on: {
          click: function ($event) {
            return _vm.close()
          },
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-container",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c("div", { staticClass: "common-content" }, [
              _c("div", { staticClass: "text-content" }, [
                _c("p", [_vm._v(_vm._s(_vm.message))]),
              ]),
              _c(
                "div",
                {
                  staticClass: "confirm-btn",
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v("確定")]
              ),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }